import React from 'react'
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import { AiFillLinkedin } from "react-icons/ai";
import { IoLocationSharp } from "react-icons/io5";
const Footer = () => {
    const today = new Date();
    const icons = [
        { id: 1, icon: <FaFacebookF size={30} className="text-white"/> , href: "https://www.facebook.com/profile.php?id=100071433043902"},
        { id: 2, icon: <FaInstagram size={30} className="text-white"/> , href: "https://www.instagram.com"},
        { id: 3, icon: <FaTwitter size={30} className="text-white"/> , href: "https://www.twitter.com"},
        { id: 4, icon: <AiFillLinkedin size={30} className="text-white"/> , href: "https://www.linkedin.com"},
    ]
  return (
    <div className="mt-10 w-full bg-gray-800 p-4">
        <div className="flex flex-col md:flex-row justify-between items-start max-w-6xl mx-auto gap-4">
           <div className="flex flex-col justify-center items-start">
             <h2 className="m-1 font-semibold underline underline-offset-2 text-lg text-inter text-gray-100">Contact Us</h2>
            <div className="flex justify-center items-start gap-2 my-2">
                <IoLocationSharp className="text-white" size={20}/>
                <p className="text-white">Birpur-02 near Fire Brigade, Bihar, India</p>
            </div>
            <div className="flex justify-center items-start gap-2 my-2">
                <BsFillTelephoneFill className="text-white" size={20}/>
                <p className="text-white">9472652042</p>
            </div>
            <div className="flex justify-center items-start gap-2 my-2">
                <MdEmail className="text-white" size={20}/>
                <p className="text-white">abc@gmail.com</p>
            </div>
           </div>
            <div className="flex flex-col gap-2 justify-center items-start">
                 <div>
                    <h2 className=" font-semibold underline underline-offset-2 text-lg text-inter text-gray-100">Follow us on</h2>
                </div>
                <div className="flex flex-row justify-between items-start gap-2">
                    { icons.map((e) => (<a key={e.id} href={e.href} target="_blank" rel="noopener noreferrer">
                            {e.icon}
                        </a>
                    ))}
                </div>
            </div>
        </div>
        <h1 className="text-center text-md text-white mt-6">Copyright &copy; {today.getUTCFullYear()} Singtel Broadband. All rights reserved</h1>
    </div>
  )
}

export default Footer;
                